import { SenseiApi } from '../utils/api';
import { SensorConfigActionTypes } from '../types/sensor-configuration';

export function fetchSelectedCaptureDetails(
  dispatch,
  jwtToken: string,
  captureId: number,
) {
  dispatch({
    type: SensorConfigActionTypes.SENSOR_CONFIG_SELECTED_CAPTURE_LOAD_START,
  });
  SenseiApi.getCaptureDetails(jwtToken, captureId)
    .then((details) => {
      // TODO - drop from backwards compatibility
      let selectedCapture = details;
      if (details.result) {
        selectedCapture = details.result;
      }

      dispatch({
        type: SensorConfigActionTypes.SENSOR_CONFIG_SELECTED_CAPTURE_LOAD_COMPLETE,
        selectedCapture: selectedCapture,
      });
    })
    .catch((reason) => {
      dispatch({
        type: SensorConfigActionTypes.SENSOR_CONFIG_SELECTED_CAPTURE_LOAD_ERROR,
        error: reason,
      });
    });
}
